import useSiteTranslation from '@/providers/i18n/hooks/useSiteTranslation';
import { PAGE_TEXTS_KEYS, customerNameRegex, zipFormatRegex } from '../../../../../../../constants/constant';
import { Button } from '../../../../ui/button';
import { CardContent } from '../../../../ui/card';
import InputField from '../../../../ui/customInput/input';
const Index = ({ FORM_FIELD_SPECS, selectedSearchType, searchParams, errors, register }: any) => {
  const Texts = useSiteTranslation(PAGE_TEXTS_KEYS?.customerAndOrderSearch);

  return (
    <CardContent className="space-y-2 lg:pr-0" key={`key_${selectedSearchType}`}>
      <div className="">
        <InputField
          items={`${Texts?.zipCode}`}
          id={FORM_FIELD_SPECS?.zipCode?.id}
          htmlFor={FORM_FIELD_SPECS?.zipCode?.id}
          register={register}
          errors={errors}
          label={Texts?.zipCode}
          classname="w-full text-base font-normal"
          rules={{
            required: Texts?.zipCodeRequired,
            pattern: {
              value: zipFormatRegex,
              message: Texts?.invalidZipCode,
            },
          }}
          defaultValue={searchParams?.[FORM_FIELD_SPECS?.zipCode?.id]}
          maxLength={FORM_FIELD_SPECS?.zipCodeSearch?.maxLength}
          isNum
        />
        <InputField
          items={`${Texts?.lastName}`}
          id={FORM_FIELD_SPECS?.lastName?.id}
          htmlFor={FORM_FIELD_SPECS?.lastName?.id}
          register={register}
          errors={errors}
          label={Texts?.lastName}
          classname="w-full mt-5 text-base font-normal"
          rules={{
            required: Texts?.lastNameRequired,
            minLength: {
              value: 2,
              message: Texts?.invalidSearchLastName,
            },
            pattern: {
              value: customerNameRegex,
              message: Texts?.invalidLastName,
            },
          }}
          defaultValue={searchParams?.[FORM_FIELD_SPECS?.lastName?.id]}
          maxLength={FORM_FIELD_SPECS?.lastName?.maxLength}
          alphaNumeric
          validateTwoCharsOrMore={true}
        />
        <InputField
          items={`${Texts?.firstNameOptional}`}
          id={FORM_FIELD_SPECS?.firstName?.id}
          htmlFor={FORM_FIELD_SPECS?.firstName?.id}
          register={register}
          errors={errors}
          label={Texts?.firstNameOptional}
          classname="w-full mt-5 text-base font-normal"
          defaultValue={searchParams?.[FORM_FIELD_SPECS?.firstName?.id]}
          maxLength={FORM_FIELD_SPECS?.firstName?.maxLength}
          rules={{
            pattern: {
              value: customerNameRegex,
              message: Texts?.invalidFirstName,
            },
          }}
        />
        <Button type="submit" className="mt-5 h-auto bg-[#002C4E] text-lg font-semibold text-white">
          {Texts?.searchButtonText}
        </Button>
      </div>
    </CardContent>
  );
};

export default Index;
